(() => {
  'use strict';
  const node = document.getElementById('DmAutoLocalizationConfig');
  if (!node || window.Shopify?.designMode) return;
  const config = JSON.parse(node.textContent);
  const manualKey = 'dm-localization-manual-v1';
  const automaticKey = 'dm-localization-auto-v1';
  const sessionKey = 'dm-localization-session-v1';
  const year = 365 * 24 * 60 * 60 * 1000;
  const read = key => {
    try { return JSON.parse(localStorage.getItem(key)) || {}; }
    catch (_) { return {}; }
  };
  let manual = read(manualKey);
  if (!(manual.expires > Date.now())) manual = {};
  const pin = (names, explicit = true) => {
    names.forEach(name => {
      if (name === 'country_code') {
        manual.country = true;
        if (explicit) manual.countryExplicit = true;
      }
      if (name === 'language_code' || name === 'locale_code') manual.language = true;
    });
    manual.expires = Date.now() + year;
    try { localStorage.setItem(manualKey, JSON.stringify(manual)); } catch (_) {}
  };
  const isLocalizationForm = form => {
    if (!form) return false;
    try { return /\/localization\/?$/.test(new URL(form.action, location.origin).pathname); }
    catch (_) { return false; }
  };
  const languageCountries = { ja: 'JP', fr: 'FR' };
  const pairLanguageCurrency = (form, name, value) => {
    if (!['locale_code', 'language_code'].includes(name)) return;
    let input = form.querySelector?.('input[data-dm-language-country]');
    const country = languageCountries[value];
    if (!country || manual.countryExplicit || !config.countries.includes(country)) {
      input?.remove();
      return;
    }
    // A form that already offers its own country choice remains authoritative.
    if (!input && form.querySelector?.('[name="country_code"]')) return;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = 'country_code';
      input.setAttribute('data-dm-language-country', '');
      form.appendChild(input);
    }
    input.value = country;
  };

  // Native buttons, select elements, and the theme's programmatic form.submit().
  document.addEventListener('click', event => {
    const choice = event.target.closest?.('button[name], input[type="submit"][name], loess-localization-form a[data-value]');
    if (!choice) return;
    const wrapper = choice.closest('loess-localization-form');
    const form = choice.closest('form') || wrapper?.querySelector('form');
    if (!isLocalizationForm(form)) return;
    const input = wrapper?.querySelector('input[name="locale_code"], input[name="country_code"]');
    const name = input?.name || choice.name;
    pairLanguageCurrency(form, name, choice.dataset?.value || choice.value);
    pin([name]);
  }, true);
  document.addEventListener('change', event => {
    if (isLocalizationForm(event.target.form)) {
      pairLanguageCurrency(event.target.form, event.target.name, event.target.value);
      pin([event.target.name]);
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (isLocalizationForm(form)) {
      const language = event.submitter?.name === 'language_code' ? event.submitter :
        form.querySelector?.('[name="locale_code"], [name="language_code"]');
      if (language) pairLanguageCurrency(form, language.name, language.value);
      pin(Array.from(form.elements).filter(input => !input.hasAttribute?.('data-dm-language-country') &&
        (!['submit', 'button'].includes(input.type) || input === event.submitter))
        .map(input => input.name).concat(event.submitter?.name || ''));
    }
  }, true);

  // Keep crawlers on the URL they requested, without automatic market/language POSTs.
  // Visible content and manual selectors remain the same for every visitor.
  if (/bot|crawler|spider|Google-InspectionTool|ChatGPT-User|Claude-User|Perplexity-User/i.test(navigator.userAgent || '')) return;

  const url = new URL(location.href);
  // A localized URL is an explicit language choice, including after a currency reload.
  const pathLanguage = url.pathname.split('/')[1].toLowerCase();
  const explicitLanguage = config.languages.some(code => code.toLowerCase() === pathLanguage);
  if (url.searchParams.has('country') || url.searchParams.has('country_code')) pin(['country_code']);
  if (url.searchParams.has('locale') || url.searchParams.has('language_code')) pin(['language_code']);

  // Never interrupt an active cart, account flow, submitted form, or theme preview.
  const path = url.pathname.replace(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i, '');
  if (config.cartCount > 0 || /^\/(cart|checkouts?|account|challenge|apps|orders)(\/|$)/.test(path) ||
      ['customer_posted', 'contact_posted', 'form_type', 'preview_theme_id'].some(key => url.searchParams.has(key))) return;

  const submitContext = (country, language) => {
    try { localStorage.setItem(automaticKey, JSON.stringify({ country, language })); } catch (_) {}
    const form = document.createElement('form');
    form.method = 'POST'; form.action = '/localization'; form.hidden = true;
    const fields = {
      form_type: 'localization', _method: 'put', country_code: country, language_code: language,
      return_to: url.pathname + url.search + url.hash
    };
    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  // Localized Japanese and French pages prefer their matching market, including
  // after this session's IP detection. An explicit country choice takes priority.
  const languageCountry = languageCountries[config.language];
  if (languageCountry && config.country !== languageCountry && !manual.countryExplicit && config.countries.includes(languageCountry)) {
    const languageSessionKey = `dm-localization-${config.language}-session-v1`;
    try {
      if (sessionStorage.getItem(languageSessionKey)) return;
      sessionStorage.setItem(languageSessionKey, '1');
      if (!sessionStorage.getItem(languageSessionKey)) return;
    } catch (_) { return; }
    submitContext(languageCountry, config.language);
    return;
  }
  try {
    if (sessionStorage.getItem(sessionKey)) return;
    sessionStorage.setItem(sessionKey, '1');
    if (!sessionStorage.getItem(sessionKey)) return;
  } catch (_) { return; }

  // Adopt existing Shopify preferences when this feature first encounters a visitor.
  const previous = read(automaticKey);
  if (config.country !== config.defaultCountry && config.country !== previous.country) pin(['country_code'], false);
  if (config.language !== config.defaultLanguage && config.language !== previous.language) pin(['language_code'], false);
  if (manual.country && manual.language) return;

  let interacted = false;
  const controller = new AbortController();
  const cancel = () => { interacted = true; controller.abort(); };
  ['pointerdown', 'click', 'keydown', 'input', 'change', 'submit'].forEach(type =>
    document.addEventListener(type, cancel, { capture: true, once: true }));
  const timer = setTimeout(() => controller.abort(), 2500);
  const root = config.root.replace(/\/?$/, '/');
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
    credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' }
  }).then(response => {
    if (!response.ok) throw new Error('Localization unavailable');
    return response.json();
  }).then(data => {
    if (interacted) return;
    const suggestion = (data.suggestions || []).find(item => item.parts?.country?.confidence >= 0.8);
    const detected = suggestion?.parts.country.handle;
    let country = !manual.country && config.countries.includes(detected) ? detected : config.country;
    const supported = config.languages.map(code => code.toLowerCase());
    let language = config.defaultLanguage;
    for (const preference of navigator.languages || [navigator.language]) {
      const full = (preference || '').toLowerCase();
      const index = supported.indexOf(full) >= 0 ? supported.indexOf(full) : supported.indexOf(full.split('-')[0]);
      if (index >= 0) { language = config.languages[index]; break; }
    }
    if (explicitLanguage || manual.language || !config.languages.includes(language)) language = config.language;
    const preferredCountry = languageCountries[language];
    if (preferredCountry && !manual.countryExplicit && config.countries.includes(preferredCountry)) country = preferredCountry;
    if (country === config.country && language === config.language) return;
    // Shopify changes the actual market and currency; retain the page and campaign parameters.
    submitContext(country, language);
  }).catch(() => {
    // Network or location failures leave the current English/USD fallback usable.
  }).finally(() => {
    clearTimeout(timer);
    ['pointerdown', 'click', 'keydown', 'input', 'change', 'submit'].forEach(type => document.removeEventListener(type, cancel, true));
  });
})();
